import { Chip } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';

// This constant holds the user's timezone, which is determined by the browser's settings.
export const USERS_TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

// This component displays the user's timezone as a small chip.
function UserTimezoneChip() {
  return (
    <Chip
      size="small"
      label={USERS_TIME_ZONE}
      sx={{
        backgroundColor: grey[100],
        color: grey[800],
        fontSize: '0.65rem',
        borderColor: grey[400],
        borderWidth: 1,
        padding: 0,
        borderStyle: 'solid',
      }}
    />
  );
}

export default UserTimezoneChip;
